import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog as MuiDialog,
} from '@mui/material';
import React from 'react';

import IconButton from '@components/IconButton';

import type {
  DialogChildrenProps,
  DialogListenerBase,
  DialogProps,
} from './types';

function Dialog({
  content,
  open,
  onClose: handleClose,
  dialogProps,
  title,
  actions,
  persistent,
  Wrapper = React.Fragment,
}: DialogProps) {
  return (
    <MuiDialog
      // Blocked aria-hidden on a element issue
      aria-hidden={!open}
      closeAfterTransition={true}
      disableRestoreFocus={true}
      open={open}
      onClick={(e) => {
        if (persistent) {
          e.stopPropagation();
        }
      }}
      onClose={(_event, reason) => {
        if (persistent && reason === 'backdropClick') {
          return;
        }
        if (
          'stopPropagation' in _event &&
          typeof _event.stopPropagation === 'function' &&
          reason === 'backdropClick'
        ) {
          _event.stopPropagation();
        }

        handleClose();
      }}
      scroll="paper"
      {...dialogProps}
    >
      <Wrapper>
        <DialogTitle marginRight={2}>{title}</DialogTitle>
        <IconButton
          name="xmark"
          onClick={handleClose}
          iconType="fas"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        />
        <DialogContent dividers={Boolean(title)}>{content}</DialogContent>
        {actions ? <DialogActions>{actions}</DialogActions> : null}
      </Wrapper>
    </MuiDialog>
  );
}

interface DialogListenerProps extends DialogListenerBase<DialogProps> {
  children: (props: DialogChildrenProps) => React.ReactNode;
}

function DialogListener(props: DialogListenerProps) {
  const { children, ...rest } = props;
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {children({
        handleOpen,
        handleClose,
      })}
      <Dialog {...rest} open={open} onClose={handleClose} />
    </>
  );
}

export default Dialog;
export { DialogListener };
